export default __webpack_public_path__ + "img/77897dc5a73b8f5e80348ec44c17ae12.svg";